const USER_ROLES = {
  ADMIN: "ADMIN",
  OPERATOR: "OPERATOR",
};

export default USER_ROLES;
